import { render, staticRenderFns } from "./situacoes-evento-form.vue?vue&type=template&id=3f05aaa5"
import script from "./situacoes-evento-form.vue?vue&type=script&lang=js"
export * from "./situacoes-evento-form.vue?vue&type=script&lang=js"
import style0 from "./situacoes-evento-form.vue?vue&type=style&index=0&id=3f05aaa5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports